<template>
  <div class="tags">
    <van-tabs v-if="reporterLabelList && reporterLabelList.length" class="tabs" v-model="active" @change="onTabChange"
      scrollspy :swipe-threshold="1">
      <van-tab v-for="label in reporterLabelList" :key="label.key" :title="label.name" :name="label.id"></van-tab>
    </van-tabs>
    <div v-if="loading" class="loading">
      <van-loading />
    </div>
    <div v-else-if="reporterList && reporterList.length" class="content">
      <div v-for="item in reporterList" :key="item.reporterUuid" class="reporter" @click="contact(item)">
        <div class="reporter-header">
          <img class="reporter-avatar" :src="item.reporterPortraitUrl || DEFAULT_AVATAR" @error="onAvatarError" />
          <div class="reporter-name">{{ item.reporterName }}</div>
        </div>
        <div class="reporter-desc">{{ item.reporterDescribe }}</div>
        <div class="reporter-btn">联系TA</div>
      </div>
      <div class="nomore">-已显示全部-</div>
    </div>
    <div v-else class="nodata-wrapper">
      <NoData />
    </div>
    <OpenApp></OpenApp>
  </div>
</template>

<script>
import { Tab, Tabs, Loading } from "vant";
import http from "../../common/js/tools/http";
import getParamsFromUrl from "../../common/utils/getParamsFromUrl";
import utils from "@common/utils";
import DEFAULT_AVATAR from "@/assets/reporter_user.png";
import OpenApp from "@/components/OpenApp/index.vue";
import NoData from "@/components/NoData/index.vue"
export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Loading.name]: Loading,
    OpenApp,
    NoData
  },
  data() {
    return {
      active: 0,
      DEFAULT_AVATAR,
      reporterLabelList: [],
      reporterList: [],
      loading: true
    };
  },
  mounted() {
    this.cardId = getParamsFromUrl()["linkId"];
    this.loadCardDetail();
  },
  methods: {
    onAvatarError(event) {
      event.target.src = DEFAULT_AVATAR;
    },
    initShare() {
      let shareOptions = {};
      shareOptions.title = `${this.cardDetail.cardName}`;
      shareOptions.desc = `“南方+”创造更多价值！`;
      shareOptions.link = window.location.href;
      shareOptions.imgUrl =
        this.cardDetail.dataMore && this.cardDetail.dataMore.aggregateShareIcon
          ? this.cardDetail.dataMore.aggregateShareIcon
          : "https://static.nfnews.com/app/nanfang_logo.png";
      utils.initWxShare(shareOptions);
    },
    loadCardDetail() {
      http
        .post(
          `${process.env.VUE_APP_MANUSCRIPT_WEB}/operate/card/get?id=${this.cardId}`
        )
        .then((res) => {
          if (res.code === 200) {
            this.cardDetail = res.data;
            this.reporterLabelList =
              res.data.reporterLabelList &&
                res.data.reporterLabelList.length > 1
                ? res.data.reporterLabelList
                : [];
            document.title = this.cardDetail.cardName;
            this.loadReporter();
            this.initShare();
          }
        });
    },
    loadReporter(labelId) {
      this.loading = true
      http
        .get(
          `${process.env.VUE_APP_MANUSCRIPT_WEB
          }/operate/card/getReporterInfoList?id=${this.cardId}&labelId=${labelId || ""
          }`
        )
        .then((res) => {
          if (res.code === 200) {
            this.reporterList = res.data.reporterInfoList;
          }
        }).finally(() => {
          this.loading = false
        });
    },
    onTabChange(labelId) {
      this.loadReporter(labelId);
    },
    contact(reporter) {
      this.$router.push({
        path: "/",
        query: {
          reporterUuid: reporter.reporterUuid,
          origin: 6,
          articleId: getParamsFromUrl()["articleId"]
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tags {
  height: 100vh;
  display: flex;
  flex-direction: column;

  ::v-deep {
    .van-tab {
      flex-grow: 0 !important;
    }

    .van-tabs__line {
      width: 0.32rem;
    }

    .van-tab__text {
      word-break: keep-all;
    }
  }
}

.tabs {
  flex-shrink: 0;
}

.content {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 0.04rem;
  padding-left: 0.32rem;
  align-content: flex-start;
}

.loading {
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reporter {
  background: #fafbfd;
  border: 0.02rem solid rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 0.15rem 0px rgba(0, 0, 0, 0.05);
  box-shadow: 0.06rem 0.1rem 0.16rem 0px rgba(0, 0, 0, 0.08);
  border-radius: 0.08rem;
  width: 3.3rem;
  height: 2.92rem;
  margin-top: 0.24rem;
  margin-right: 0.26rem;
  padding: 0.16rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:nth-child(2n+2) {
    margin-right: 0;
  }

  &-header {
    display: flex;
    width: 100%;
    align-items: center;
  }

  &-avatar {
    width: 0.92rem;
    height: 0.92rem;
    border-radius: 50%;
    flex-shrink: 0;
  }

  &-name {
    flex: 1;
    margin-left: 0.16rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: keep-all;
    overflow: hidden;
    font-size: 0.32rem;
    color: #333333;
    line-height: 0.44rem;
  }

  &-desc {
    font-size: 0.24rem;
    color: #999999;
    line-height: 0.34rem;
    font-weight: 400;
    width: 100%;
    margin-top: 0.16rem;
    height: 0.68rem;
    overflow: hidden;
    display: -webkit-box;
    /*! autoprefixer: off; */
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
  }

  &-btn {
    border: 0.02rem solid rgba(246, 78, 69, 0.2);
    border-radius: 0.32rem;
    width: 1.6rem;
    height: 0.64rem;
    align-self: center;
    margin-top: 0.16rem;
    text-align: center;
    line-height: 0.6rem;
    font-size: 0.28rem;
    color: #f64e45;
  }
}

.nomore {
  font-size: 0.28rem;
  color: #999999;
  text-align: center;
  line-height: 0.28rem;
  font-weight: 400;
  margin-top: 0.32rem;
  padding-bottom: 0.64rem;
  width: 100%;
  margin-right: 0.32rem;
}

.nodata-wrapper {
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
